import http from './http'

const PRODUCT_CHANNEL = 'dodo'

const VIP_PERIOD_ID_MAP = {
  7: 'vip_7days',
  30: 'vip_monthly',
  365: 'vip_yearly'
}

const VIP_TITLE_MAP = {
  vip_7days: 'Weekly VIP',
  vip_monthly: 'Monthly VIP',
  vip_yearly: 'Yearly VIP'
}

let productListRequest = null

const centsToDollars = (value) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return value
  return Number((n / 100).toFixed(2))
}

const normalizeProduct = (raw) => {
  const productId = raw.product_id ?? raw.productId
  const originPrice = centsToDollars(raw.origin_price ?? raw.originPrice ?? raw.originalPrice)
  const type = raw.type === 1 || raw.type === '1' || raw.type === 'coin' || raw.type === 'coins'
    ? 'coins'
    : raw.type === 2 || raw.type === '2' || raw.type === 'vip'
      ? 'vip'
      : raw.type
  const id = type === 'vip'
    ? (VIP_PERIOD_ID_MAP[Number(raw.period || 0)] ?? productId)
    : productId
  const freeDays = Number(raw.free_days ?? raw.freeDays ?? 0)
  const product = {
    ...raw,
    id,
    productId,
    product_id: productId,
    type,
    price: centsToDollars(raw.price),
    originPrice,
    originalPrice: originPrice,
    origin_price: originPrice,
    freeDays: Number.isFinite(freeDays) && freeDays > 0 ? Math.floor(freeDays) : 0,
    free_days: Number.isFinite(freeDays) && freeDays > 0 ? Math.floor(freeDays) : 0
  }
  if (type === 'vip') {
    product.title = VIP_TITLE_MAP[id] ?? productId
  }
  return product
}

const isLimitProduct = (product) => {
  return !!product?.is_one_time || !!product?.isOneTime || Number(product?.valid_time || 0) > 0
}

const getPaymentProducts = async () => {
  if (!productListRequest) {
    productListRequest = http.get('/api/payment/products', { channel: PRODUCT_CHANNEL })
      .catch((error) => {
        productListRequest = null
        throw error
      })
  }
  return productListRequest
}

const getNormalizedProducts = async () => {
  const result = await getPaymentProducts()
  const list = Array.isArray(result) ? result : []
  return list.map(normalizeProduct)
}

export const getWalletProducts = async () => {
  const products = await getNormalizedProducts()
  return { products: products.filter(product => !isLimitProduct(product)) }
}

export const getLimitProduct = async () => {
  const products = await getNormalizedProducts()
  return { product: products.find(isLimitProduct) || null }
}

const getDodoReturnUrl = () => {
  const origin = window.location.origin
  return `${origin}/pay/callback`
}

const normalizeCheckoutUrl = (data) => {
  if (typeof data === 'string') return data.trim()
  if (typeof data?.checkout_url === 'string') return data.checkout_url.trim()
  if (typeof data?.checkoutUrl === 'string') return data.checkoutUrl.trim()
  if (typeof data?.url === 'string') return data.url.trim()
  return ''
}

export const createDodoPayment = async (productId) => {
  const data = await http.post('/api/payment/dodo/pay', {
    product_id: productId,
    return_url: getDodoReturnUrl()
  })
  const checkoutUrl = normalizeCheckoutUrl(data)
  if (!checkoutUrl) {
    throw new Error('empty checkout url')
  }
  return checkoutUrl
}

export const getDodoPaymentStatus = (sessionId) => {
  return http.get('/api/payment/dodo/status', { session_id: sessionId })
}

const normalizeCoinHistoryItem = (raw = {}) => {
  const watchCoins = Number(raw.watchCoins || 0)
  const watchBonus = Number(raw.watchBouns ?? raw.watchBonus ?? 0)
  return {
    timestamp: Number(raw.timeStamp ?? raw.timestamp ?? 0),
    type: typeof raw.type === 'string' ? raw.type : '',
    watchCoins,
    watchBonus
  }
}

export const getCoinHistory = async (page = 1, pageSize = 20) => {
  const result = await http.get('/api/payment/coins/history', { page, pageSize })
  const list = Array.isArray(result) ? result : []
  return list
    .map(normalizeCoinHistoryItem)
    .filter(item => item.watchCoins !== 0 || item.watchBonus !== 0)
}
